import { apiHost } from '../../../config';
import { get } from '../../requests';

export default async function getAllQuestions() {
  return get(`${apiHost}/api/testing/questions`);
}
